import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ProfileService } from 'src/app/services/profile.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-money-out-categorize',
  templateUrl: './money-out-categorize.component.html',
  styleUrls: ['./money-out-categorize.component.scss'],
})
export class MoneyOutCategorizeComponent implements OnInit {

  @Input() user: any;
  @Input() isMoneyIn: boolean = false;
  @Input() walletStatus: number;
  @Output() public continueEvent = new EventEmitter<any>();

  loading: boolean = true;
  step: number = 0;
  profileIsEnrolledSca: boolean = false;
  profileHasConsent: boolean = false;
  initText: string;
  finishText: string;
  initBtnList = [
    {
      type: 'primaryDark',
      index: 1,
      title: this.translate.instant('bid-create.continue'),
    }
  ];

  constructor(
    private profileService: ProfileService,
    private chdRef: ChangeDetectorRef,
    private translate: TranslateService,
    private utilsService: UtilsService
  ) { }

  ngOnInit() {
    this.initText = this.walletStatus === 0 ? this.translate.instant('MOVEMENTS.NO_MONEY_IN_NEED_TO_CONSENTS') : !this.isMoneyIn ? this.translate.instant('MOVEMENTS.NO_MONEY_OUT_AVAILABLE_2') : this.translate.instant('MOVEMENTS.NO_MONEY_IN_AVAILABLE');
    this.finishText = this.walletStatus === 0 ? this.translate.instant('MOVEMENTS.CATEGORIZED_MSG') : !this.isMoneyIn ? this.translate.instant('MOVEMENTS.NO_MONEY_OUT_VALIDATING') : this.translate.instant('MOVEMENTS.NO_MONEY_IN_VALIDATING');
    this.profileService.getProfile(this.user.username).subscribe(resp => {
      const params = this.utilsService.getMangopayValidationParams(resp);
      if (!params) {
        this.step = 2;
      } else {
        this.profileIsEnrolledSca = params.isEnrolledSca;
        this.profileHasConsent = params.hasConsentGranted;
      }
      this.loading = false;
      this.chdRef.detectChanges();
    });
    this.chdRef.detectChanges();
  }

  next() {
    this.step++;
    this.chdRef.detectChanges();
  }

  continue() {
    this.continueEvent.emit();
    this.chdRef.detectChanges();
  }
}
